// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import translate from 'i18n-jsautotranslate'
import VueCoreVideoPlayer from 'vue-core-video-player'

import '@/plugins/i18nUtils.js'

translate.setUseVersion2() //设置使用v2.x 版本
translate.selectLanguageTag.show = false //是否显示切换栏
translate.listener.start() //监控页面动态渲染的文本进行自动翻译
Vue.prototype.$translate = translate
Vue.use(VueCoreVideoPlayer)



/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'
Vue.config.productionTip = false;
Vue.prototype.http = axios;
Vue.prototype.api = api;
// axios.defaults.baseURL = '请求地址';//后端开发环境地址
/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* 字体样式 */
import './assets/css/fonts.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
import VueI18n from 'vue-i18n'
import i18n from './i18n' // 确保路径正确
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false

Vue.use(VueI18n);
Vue.use(Antd);


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title

    }
    next();
});


new Vue({
  el: '#app',
  router,
  mounted() {
    window.isfitVue = this;
  },
  i18n,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js